import React, { FC, useState } from 'react'
import { IProps } from '.'

import useTranslate from '../../hooks/useTranslate'
import { Text } from 'marketing-site/src/library/elements/Text'
import { Icon } from 'marketing-site/src/mvp/library/elements/Icon'

export const LocalePicker: FC<IProps> = ({ contentType, locales, selected = '', id, onChange }) => {
  const [value, setValue] = useState<string>(selected)
  const { translate } = useTranslate()

  const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (!event?.target?.value) return

    setValue(event.target.value)

    if (onChange) {
      onChange(event.target.value)
    }
  }

  const currentValue = locales.find((locale) => locale.code === value)?.name

  return (
    <>
      <div className="locale-picker">
        <svg
          className="icon icon--globe"
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.875 13.625C10.2577 13.625 13 10.8827 13 7.5C13 4.11726 10.2577 1.375 6.875 1.375C3.49226 1.375 0.75 4.11726 0.75 7.5C0.75 10.8827 3.49226 13.625 6.875 13.625Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.87448 13.625C8.09903 13.625 9.09171 10.8827 9.09171 7.5C9.09171 4.11726 8.09903 1.375 6.87448 1.375C5.64992 1.375 4.65723 4.11726 4.65723 7.5C4.65723 10.8827 5.64992 13.625 6.87448 13.625Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.14355 5.54004H12.585"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.14355 9.45996H12.585"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="locale-picker__placeholder">
          <Text brand={contentType === 'flex' ? 'default' : 'mvp'} size="caption">
            {translate(currentValue ?? '')}
          </Text>
        </div>
        <Icon icon="caret-down" />
        {/* eslint-disable-next-line jsx-a11y/no-onchange*/}
        <select className="locale-picker__select" name={id} id={id} onChange={onSelectChange}>
          {locales.map((locale) => (
            <option key={locale.code} value={locale.code} selected={locale.code === value}>
              {translate(locale.name)}
            </option>
          ))}
        </select>
      </div>

      <style jsx>{`
        .locale-picker {
          position: relative;

          &__placeholder {
            padding: 0 1.25rem;

            :global(span) {
              color: inherit;
            }
          }

          .icon--globe,
          :global(.icon--caret-down) {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }

          .icon--globe {
            left: 0;
          }

          :global(.icon--caret-down) {
            right: 0;
          }

          &__select {
            position: absolute;
            padding: 0;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            appearance: none;
            background-color: transparent;
            font-size: 0;
            background-repeat: no-repeat, no-repeat;
            background-size: 14px, 16px;
            transition: outline 0.25s;
            cursor: pointer;
            border: none;
            z-index: 1;

            option {
              font-size: 13px;
            }

            &:focus {
              outline: none;
            }
          }
        }
      `}</style>
    </>
  )
}
